import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://skclkisbzaeljxaiujah.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNrY2xraXNiemFlbGp4YWl1amFoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTg0MTk2MjAsImV4cCI6MjA3Mzk5NTYyMH0.e0KIsmw-D8kZ_6r3SlwU80FHhL3YR8aoFuRE7eMVQf8'

if(!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})

export default supabase